module.exports = __webpack_public_path__ + "static/media/no_data.f33ad1bb.svg";